import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';

import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'



import tinymce from 'vue-tinymce-editor'
import  axios from  'axios';
window.axios = axios;
window.axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;

// eslint-disable-next-line no-console
import {initAuthService} from "./services/authService";
import moment from "moment";
window.axios = axios;

import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast, {
  position : "top-right"
});
//Vue.$toast.open({/* options */});

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(axios)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
initAuthService()
Vue.filter('not_defined', function (value) {
  if (!value) return 'No data'
  return value
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('replaceUnderscore', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.replace(/_/g, ' ');
})
Vue.filter('timeAgo', function (value) {
  if (!value) return ''
  value = value.toString()
  return moment(value, 'YYYY-MM-DD HH:mm:ss').fromNow()
})
Vue.filter('timeFormat', function (time) {
  if (!time || time == 0) return '0'

  try{
    time = Number.parseInt(time.toString())/1000;
  }catch (e){
    return '0'
  }
  return getDurationText(time);
})
function getDurationText(time) {
  const duration = moment.duration(time, "seconds");
  const years = duration.years();
  const months = duration.months();
  const weeks = duration.weeks();
  const days = duration.subtract(weeks, "w").days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const milliseconds = duration.milliseconds();

  const yearsText = getDurationTextOrDefault(years, "Year,");
  const monthsText = getDurationTextOrDefault(months, "Month");
  const weeksText = getDurationTextOrDefault(weeks, "Week");
  const daysText = getDurationTextOrDefault(days, "Day");
  const hoursText = getDurationTextOrDefault(hours, "Hour");
  const minutesText = getDurationTextOrDefault(minutes, "Minute");
  const secondsText = getDurationTextOrDefault(seconds, "Second");

  return `${yearsText}${monthsText}${weeksText}${daysText}${hoursText}${minutesText}${secondsText}`;
}
function getDurationTextOrDefault(duration, unit) {
  if (duration <= 0) return "";
  unit = duration === 1 ? unit : unit + "s";
  return `${duration} ${unit} `;
}
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
